module.exports = __webpack_public_path__ + "static/media/kids_17.ce4e3c08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_17.jpg
// module id = 5873
// module chunks = 0